// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 831 ? "b5c69090" : chunkId) + "." + {"268":"986bb8876eaad44d","316":"aaa975d534c64d6d","652":"29b74410223d1e20","668":"1ca5176fe4d1a212","831":"2e7bd0c5d41d2ad1"}[chunkId] + ".js";
};